import { ConcreteEncodable } from "./ConcreteEncodable";

import { TimeImplEncoder } from "../../encoder/TimeImplEncoder";

import * as CubiqTS from "../../index";
import { Time } from "../Time";

export class TimeImpl extends ConcreteEncodable implements Time {
  public static enType: string = "com.bcdfx.model.TimeImpl";

  /*FID=1*/
  public hour: number;
  /*FID=2*/
  public min: number;
  /*FID=3*/
  public second: number;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TimeImplEncoder.Instance;
    this.setEncodableType(TimeImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TimeImpl[" +
      "hour=" +
      this.hour +
      "min=" +
      this.min +
      "second=" +
      this.second +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
